var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-record-form" },
    [
      _c(
        "a-steps",
        {
          style: _vm.stepStyle,
          attrs: { type: "navigation", size: "small" },
          model: {
            value: _vm.current,
            callback: function ($$v) {
              _vm.current = $$v
            },
            expression: "current",
          },
        },
        [
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.selectContactFile"),
              description: _vm.$t("wp.selectContactCsvOrExcel"),
              status: _vm.current === 0 ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.importConfiguration"),
              description: _vm.$t("wp.customizeFile"),
              status: _vm.current === 1 ? "process" : "wait",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.current === 0
        ? _c("div", { staticClass: "fileSelection" }, [
            _c(
              "div",
              { staticClass: "file-box", on: { click: _vm.openSelectFile } },
              [
                _c(
                  "div",
                  {},
                  [
                    _c("a-icon", {
                      staticStyle: { "font-size": "50px", color: "#08c" },
                      attrs: { type: "laptop" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "file-details" }, [
                  _vm.file
                    ? _c("span", [_vm._v(_vm._s(_vm.file.name))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.uploadFromComputer")))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.csvOrExcelFile")))]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "file-box",
                on: { click: _vm.openSupsisDrivePicker },
              },
              [
                _c(
                  "div",
                  {},
                  [
                    _c("a-icon", {
                      staticStyle: { "font-size": "50px", color: "#667eea" },
                      attrs: { type: "cloud" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "file-details" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("table.supsisDrive")))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.csvOrExcelFile")))]),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.hasGoogleDriveChannels
              ? _c(
                  "div",
                  {
                    staticClass: "file-box",
                    on: { click: _vm.openGoogleDrivePicker },
                  },
                  [
                    _c(
                      "div",
                      {},
                      [
                        _c("GoogleDriveIcon", {
                          staticStyle: { width: "50px", height: "50px" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "file-details" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("table.googleDrive")))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("wp.csvOrExcelFile")))]),
                    ]),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showSupsisDrivePicker
        ? _c("FilePicker", {
            attrs: { multiple: false },
            on: {
              cancel: function ($event) {
                _vm.showSupsisDrivePicker = false
              },
              confirm: _vm.handleSupsisDriveSelect,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showGoogleDrivePicker
        ? _c("GoogleDriveFilePicker", {
            attrs: { multiple: false },
            on: {
              cancel: function ($event) {
                _vm.showGoogleDrivePicker = false
              },
              confirm: _vm.handleGoogleDriveSelect,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.current === 1
        ? _c("div", { staticClass: "configuration" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("section", { staticClass: "general" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("tables.firstRowHeader")) + " ? "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-switch", {
                        model: {
                          value: _vm.firstRowContainsHeader,
                          callback: function ($$v) {
                            _vm.firstRowContainsHeader = $$v
                          },
                          expression: "firstRowContainsHeader",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.excelMode
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("message.separatorCharacter")) +
                                " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.seperator,
                                callback: function ($$v) {
                                  _vm.seperator = $$v
                                },
                                expression: "seperator",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "," } }, [
                                _vm._v(_vm._s(_vm.$t("tables.comma")) + " (,)"),
                              ]),
                              _vm._v(" "),
                              _c("a-select-option", { attrs: { value: ";" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("tables.semicolan")) + " (;)"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c("section", { staticClass: "attributes" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("tables.tableFieldOrFileColumns"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "attributes-items" },
                    _vm._l(_vm.table.fields, function (field) {
                      return _vm.isValidField(field)
                        ? _c(
                            "div",
                            { key: field._id, staticClass: "attribute" },
                            [
                              _c("div", { staticClass: "field" }, [
                                _c("label", [_vm._v(_vm._s(field.name))]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "field" },
                                [
                                  _c("a-select", {
                                    attrs: {
                                      options: _vm.getSelectOptionsForColumns(),
                                    },
                                    model: {
                                      value: _vm.fieldColumnMap[field._id],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.fieldColumnMap,
                                          field._id,
                                          $$v
                                        )
                                      },
                                      expression: "fieldColumnMap[field._id]",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "section",
                { staticClass: "result" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("tables.exampleResultPreview"))),
                  ]),
                  _vm._v(" "),
                  _c("a-table", {
                    style: { width: "100%" },
                    attrs: {
                      columns: _vm.getTableDataSource().columns,
                      "data-source": _vm.getTableDataSource().rows,
                      pagination: false,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "footer" },
                [
                  _c("a-button", { on: { click: _vm.onCancelled } }, [
                    _vm._v(_vm._s(_vm.$t("message.cancel"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.importing },
                      on: { click: _vm.save },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.importing
                              ? "Importing"
                              : _vm.$t("message.importRecords")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }